var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../babel-loader/lib/index.js??ref--14-1!./utils.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
var ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___ = ___EXPOSE_LOADER_IMPORT___["default"];
___EXPOSE_LOADER_GLOBAL_THIS___["intlTelInputUtils"] = ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___;
module.exports = ___EXPOSE_LOADER_IMPORT___;